export const UPDATE_TIME_DELAY = 30000;
export const CHECK_TIME_DELAY = 35000;
export const SALESFORCE_LAST_UPDATED_AT_FIELD_NAME = 'salesforceLastUpdatedAt';
export const EDITING_USER_ID_FIELD_NAME = 'editingUserId';
export const FIRESTORE_COLLECTION = 'collection';
export const FIRESTORE_DOCUMENT = 'document';
